<script>
  import Layout from '@layouts/main.vue'

  export default {
    page: {
      title: '404',
      meta: [{ name: 'description', content: '404' }],
    },
    components: { Layout },
    props: {
      // prop passed to the 404 page through the route param,
      // to define what wasn't found.
      resource: {
        type: String,
        default: '',
      },
    },
  }
</script>

<template>
  <Layout>
    <el-row :class="$style.notFoundView" type="flex" justify="end" align="middle">
      <el-col :span="24" :md="{ span: 22, offset: 1 }" :class="$style.detailsContainer">
        <h1 :class="$style.title">404</h1>
        <p>Ooops, how'd you get here?</p>
        <template v-if="resource">
          {{ resource }}
        </template>

        <router-link
            :to="{ name: 'base' }"
            tag="button"
            type="info"
            class="el-button is-round el-button--info el-button--medium el-button--outline">
          Take me home
        </router-link>
      </el-col>
    </el-row>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';

  .notFoundView {
    height: 75vh;
    text-align: center;
  }

  .detailsContainer {
    h1 {
      margin-bottom: 20px;
      font-size: 6rem;
      color: $color-light-grey;
    }

    p {
      margin-bottom: 40px;
      font-size: 1.8rem;
      color: $color-text-tetriary;
    }
  }
</style>
